/* eslint-disable no-unused-vars */
import React, { useContext } from 'react';
import axios from 'axios';
import { CotizadorContext } from '../context';

const useExtrasData = () => {
    const [state, setState] = useContext(CotizadorContext)

    const getExtras = async () => {
        const response = await axios.get('/api/kinto/extras');
        setState(prevState => ({
            ...prevState,
            available_extras: response.data
        }))
    }

    const toggleExtra = extra => {
        setState(prevState => {
            const selected_extras = prevState.selected_extras;
            const extra_index = selected_extras.indexOf(extra);
            if (extra_index < 0) {
                selected_extras.push(extra)
            } else {
                selected_extras.splice(extra_index,1);
            }

            return {
                ...prevState,
                selected_extras
            }
        });
    }

    const isExtraSelected = extra => {
        return state.selected_extras.indexOf(extra) >= 0;
    }

    const getExtraItem = extra_id => {
        return state.available_extras.find(extra => extra.id === extra_id);
    }

    return {
        extras: state.available_extras,
        selectedExtras: state.selected_extras,
        getExtras,
        toggleExtra,
        isExtraSelected,
        getExtraItem
    };
}

export default useExtrasData;